/*
 *
 *  actions
 *
 */

import {
  LOAD_PACKAGES_LIST,
  LOAD_PACKAGES_LIST_SUCCESS,
  LOAD_PACKAGES_LIST_ERROR,
  LOAD_PACKAGES_TOTAL_LIST,
  LOAD_PACKAGES_TOTAL_LIST_SUCCESS,
  LOAD_PACKAGES_TOTAL_LIST_ERROR,
  LOAD_DESTINATION_SEARCH_LIST,
  LOAD_DESTINATION_SEARCH_LIST_SUCCESS,
  LOAD_DESTINATION_SEARCH_LIST_ERROR,
  LOAD_PACKAGES_LIST_RECORDS_META_DATA,
  LOAD_PACKAGES_LIST_RECORDS_META_DATA_SUCCESS,
  LOAD_PACKAGES_LIST_RECORDS_META_DATA_ERROR,
  LOAD_PACKAGES_SINGLE_LIST,
  LOAD_PACKAGES_SINGLE_LIST_SUCCESS,
  LOAD_PACKAGES_SINGLE_LIST_ERROR,
  LOAD_TERMS_AND_CONDITIONS_LIST,
  LOAD_TERMS_AND_CONDITIONS_LIST_SUCCESS,
  LOAD_TERMS_AND_CONDITIONS_LIST_ERROR,
  LOAD_TERMS_SINGLE_CONDITIONS_LIST,
  LOAD_TERMS_SINGLE_CONDITIONS_LIST_SUCCESS,
  LOAD_TERMS_SINGLE_CONDITIONS_LIST_ERROR,
  LOAD_PACKAGES_FAQ_LIST,
  LOAD_PACKAGES_FAQ_LIST_SUCCESS,
  LOAD_PACKAGES_FAQ_LIST_ERROR,
  LOAD_PACKAGES_FAQ_MAIN_LIST,
  LOAD_PACKAGES_FAQ_MAIN_LIST_SUCCESS,
  LOAD_PACKAGES_FAQ_MAIN_LIST_ERROR,
  LOAD_TRAVELLER_AGE_RESTRICTIONS,
  LOAD_TRAVELLER_AGE_RESTRICTIONS_SUCCESS,
  LOAD_TRAVELLER_AGE_RESTRICTIONS_ERROR,
} from "./constants";

// load payment in
export function loadPackagesTotalList(destinations) {
  return {
    type: LOAD_PACKAGES_TOTAL_LIST,

    destinations,
  };
}

export function loadPackagesTotalListSuccess(packages_total_list, success) {
  return {
    type: LOAD_PACKAGES_TOTAL_LIST_SUCCESS,
    packages_total_list,
    success,
  };
}

export function loadPackagesTotalListError(error) {
  return {
    type: LOAD_PACKAGES_TOTAL_LIST_ERROR,
    error,
  };
}
export function loadPackagesList(destinations) {
  return {
    type: LOAD_PACKAGES_LIST,
    destinations,
  };
}

export function loadPackagesListSuccess(packages_list, success) {
  return {
    type: LOAD_PACKAGES_LIST_SUCCESS,
    packages_list,
    success,
  };
}

export function loadPackagesListError(error) {
  return {
    type: LOAD_PACKAGES_LIST_ERROR,
    error,
  };
}
export function loadDestinationSearchList(destinations) {
  return {
    type: LOAD_DESTINATION_SEARCH_LIST,
    destinations,
  };
}

export function loadDestinationSearchListSuccess(destination_search_list, success) {
  return {
    type: LOAD_DESTINATION_SEARCH_LIST_SUCCESS,
    destination_search_list,
    success,
  };
}

export function loadDestinationSearchListError(error) {
  return {
    type: LOAD_DESTINATION_SEARCH_LIST_ERROR,
    error,
  };
}

//payment in report

// load payment in
export function loadPackageSingleList(destinations) {
  return {
    type: LOAD_PACKAGES_SINGLE_LIST,
    destinations,
  };
}

export function loadPackageSingleListSuccess(packages_single_list, success) {
  return {
    type: LOAD_PACKAGES_SINGLE_LIST_SUCCESS,
    packages_single_list,
    success,
  };
}

export function loadPackageSingleListError(error) {
  return {
    type: LOAD_PACKAGES_SINGLE_LIST_ERROR,
    error,
  };
}

export function loadPackageListRecordsMetaData() {
  return {
    type: LOAD_PACKAGES_LIST_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadPackageListRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_PACKAGES_LIST_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadPackageListRecordsMetaDataError(error) {
  return {
    type: LOAD_PACKAGES_LIST_RECORDS_META_DATA_ERROR,
    error,
  };
}

export function loadTermsConditionsList() {
  return {
    type: LOAD_TERMS_AND_CONDITIONS_LIST,
  };
}

export function loadTermsConditionsListSuccess(terms_conditions, success) {
  return {
    type: LOAD_TERMS_AND_CONDITIONS_LIST_SUCCESS,
    terms_conditions,
    success,
  };
}

export function loadTermsConditionsListError(error) {
  return {
    type: LOAD_TERMS_AND_CONDITIONS_LIST_ERROR,
    error,
  };
}

//payment in report

// load terms single
export function loadTermsConditionsSingleList(destinations) {
  return {
    type: LOAD_TERMS_SINGLE_CONDITIONS_LIST,
    destinations,
  };
}

export function loadTermsConditionsSingleListSuccess(
  terms_single_conditions_list,
  success
) {
  return {
    type: LOAD_TERMS_SINGLE_CONDITIONS_LIST_SUCCESS,
    terms_single_conditions_list,
    success,
  };
}

export function loadTermsConditionsSingleListError(error) {
  return {
    type: LOAD_TERMS_SINGLE_CONDITIONS_LIST_ERROR,
    error,
  };
}
// load terms single
export function loadPackagesFaqList(destinations) {
  return {
    type: LOAD_PACKAGES_FAQ_LIST,
    destinations,
  };
}

export function loadPackagesFaqListSuccess(packages_faq_list, success) {
  return {
    type: LOAD_PACKAGES_FAQ_LIST_SUCCESS,
    packages_faq_list,
    success,
  };
}

export function loadPackagesFaqListError(error) {
  return {
    type: LOAD_PACKAGES_FAQ_LIST_ERROR,
    error,
  };
}
// load package faq single
export function loadPackagesFaqMainList(destinations) {
  return {
    type: LOAD_PACKAGES_FAQ_MAIN_LIST,
    destinations,
  };
}

export function loadPackagesFaqMainListSuccess(
  packages_faq_main_list,
  success
) {
  return {
    type: LOAD_PACKAGES_FAQ_MAIN_LIST_SUCCESS,
    packages_faq_main_list,
    success,
  };
}

export function loadPackagesFaqMainListError(error) {
  return {
    type: LOAD_PACKAGES_FAQ_MAIN_LIST_ERROR,
    error,
  };
}
// load TRAVELLER AGE RESTRICTIONS
export function loadTravellerAgeRestrictions(destinations) {
  return {
    type: LOAD_TRAVELLER_AGE_RESTRICTIONS,
    destinations,
  };
}

export function loadTravellerAgeRestrictionsSuccess(
  traveller_age_restrictions,
  success
) {
  return {
    type: LOAD_TRAVELLER_AGE_RESTRICTIONS_SUCCESS,
    traveller_age_restrictions,
    success,
  };
}

export function loadTravellerAgeRestrictionsError(error) {
  return {
    type: LOAD_TRAVELLER_AGE_RESTRICTIONS_ERROR,
    error,
  };
}

const actions = {
  loadPackagesList,
  loadPackagesListSuccess,
  loadPackagesListError,
  loadDestinationSearchList,
  loadDestinationSearchListSuccess,
  loadDestinationSearchListError,
  loadPackageSingleList,
  loadPackageSingleListSuccess,
  loadPackageSingleListError,
  loadTermsConditionsList,
  loadTermsConditionsListSuccess,
  loadTermsConditionsListError,
  loadPackagesFaqList,
  loadPackagesFaqListSuccess,
  loadPackagesFaqListError,
  loadPackagesFaqMainList,
  loadPackagesFaqMainListSuccess,
  loadPackagesFaqMainListError,
  loadTravellerAgeRestrictions,
  loadTravellerAgeRestrictionsSuccess,
  loadTravellerAgeRestrictionsError,
  loadTermsConditionsSingleList,
  loadTermsConditionsSingleListSuccess,
  loadTermsConditionsSingleListError,

  loadPackageListRecordsMetaData,
  loadPackageListRecordsMetaDataSuccess,
  loadPackageListRecordsMetaDataError,
};

export default actions;
